import { render, staticRenderFns } from "./BlwAvatar.vue?vue&type=template&id=40487f52&"
import script from "./BlwAvatar.vue?vue&type=script&lang=js&"
export * from "./BlwAvatar.vue?vue&type=script&lang=js&"
import style0 from "./BlwAvatar.vue?vue&type=style&index=0&id=40487f52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports